(() => {
  const title = document.currentScript.dataset.heading;
  const main = document.getElementById('MainContent');
  if (!main || !title) return;
  const updateHeading = () => {
    main.querySelectorAll('.valued-product-reviews > .head h2').forEach(heading => {
      if (heading.textContent !== title) heading.textContent = title;
    });
  };
  updateHeading();
  new MutationObserver(updateHeading).observe(main, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
